import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/system';
// ----------------------------------------------------------------------
// @TODO: Integrate tooltip directly in here
// This avoids having to import the tooltip component in every file
const CustomIconButton = styled(IconButton)(({ theme }) => ({
    '&:focus': { backgroundColor: '#2b3287' },
}));
// ----------------------------------------------------------------------
export { CustomIconButton as IconButton };
